import { rootApi } from 'root-api'

const tagInvalidations = [
  'MEETING_TYPES_LIST',
  'PROFILE_MEETING_TYPES_LIST',
  'EVENT_TYPE_LIST',
  'PROFILE_EVENT_TYPE_LIST',
  'WIZARD_METADATA'
]

const api = rootApi.injectEndpoints({
  endpoints: (build) => ({
    fetchEventTypesForSelection: build.query({
      query: () => ({
        url: '/api/users/me/event_types',
        params: {
          scope: 'personal',
          skip_pagination: true,
          count: 30
        }
      })
    }),
    activateEventTypeforSelection: build.mutation({
      query: ({ eventTypeId }) => ({
        url: `/api/users/me/event_types/${eventTypeId}/activate`,
        method: 'PUT'
      }),
      invalidatesTags: tagInvalidations
    }),
    deactivateEventTypeforSelection: build.mutation({
      query: ({ eventTypeId }) => ({
        url: `/api/users/me/event_types/${eventTypeId}/deactivate`,
        method: 'PUT'
      }),
      invalidatesTags: tagInvalidations
    })
  })
})

export const {
  useFetchEventTypesForSelectionQuery,
  useActivateEventTypeforSelectionMutation,
  useDeactivateEventTypeforSelectionMutation
} = api
